import { backendClient } from '@/lib/api-client';
import type { MembershipRequest } from '@/types/base';
import useSWR, { mutate } from 'swr';

const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

const useMembershipRequests = (matterGuid: string) => {
  const url = `/matter/${matterGuid}/membership-requests`;

  const { data, error, isLoading } = useSWR<MembershipRequest[]>(
    url,
    fetcher
  );

  const mutateMembershipRequests = async () => {
    mutate(url);
  };

  return {
    isLoading,
    isError: error,
    requests: data ?? [],
    mutateMembershipRequests,
  };
};

export default useMembershipRequests;